export class SuperUserApiModel {
  public Email = '';
  public Id = '';
  public FirstName = '';
  public LastName = '';
  public LastLogin: Date | null = null;
  public AvatarSrc: string;

  public deserialize(data: Object): SuperUserApiModel {
    Object.assign(this, data);
    if (this.LastLogin) {
      this.LastLogin = new Date(this.LastLogin);
    }
    return this;
  }
}
